import { render } from "./ClassroomDetail.vue?vue&type=template&id=0c6156c1"
import script from "./ClassroomDetail.vue?vue&type=script&lang=js"
export * from "./ClassroomDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__